import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { PropsWithChildren } from 'react';

import { FormattedMessage } from '@flipster/i18n';
import { Styles, css } from '@flipster/styled-system/css';
import { center, grid, stack } from '@flipster/styled-system/patterns';

import { MasterTraderCard } from './master-trader-card';
import { meetMasterTraderBunja } from './state';
import { MeetMasterTraderToolbar } from './toolbar';

export const MeetMasterTrader = ({ css: cssProps }: { css: Styles }) => {
  const { portfoliosAtom, sortedPortfoliosAtom } = useBunja(meetMasterTraderBunja);
  const portfolios = useAtomValue(portfoliosAtom);
  const sortedPortfolios = useAtomValue(sortedPortfoliosAtom);
  const totalCount = portfolios.length;

  return (
    <div className={css(stack.raw({ gap: 20 }), totalCount === 1 && { gap: 40, alignItems: 'center' }, cssProps)}>
      <p className={css({ textStyle: 'Title/S', color: 'content.default.level-5' })}>
        <FormattedMessage id='Copy.r251208.Meet_our_count_master_traders' values={{ count: totalCount }} />
      </p>
      <div
        className={css({
          pos: 'sticky',
          top: '{sizes.navigationHeight}',
          zIndex: 2,
          w: '100%',
          py: 12,
          bg: 'background.default.level-0',
        })}
      >
        <MeetMasterTraderToolbar />
      </div>
      <div
        className={grid({
          w: '100%',
          tablet: { gridTemplateColumns: 'repeat(auto-fit, minmax(330px, 1fr))' },
          gap: 16,
        })}
      >
        {sortedPortfolios.map((portfolio) => (
          <MasterTraderCard
            key={portfolio.portfolioId}
            portfolio={portfolio}
            color={totalCount === 1 ? 'dark' : 'light'}
          />
        ))}
      </div>
      {totalCount < 3 && (
        <p
          className={css({
            textStyle: 'Text/L/Regular',
            color: 'content.default.level-2',
            textAlign: 'center',
          })}
        >
          <FormattedMessage id='Copy.r251107.More_masters_on_their_way_stay_tuned' />
        </p>
      )}
    </div>
  );
};

export const MeetMasterTraderSingleContainer = ({ children }: PropsWithChildren) => {
  const { portfoliosAtom } = useBunja(meetMasterTraderBunja);
  const portfolios = useAtomValue(portfoliosAtom);
  if (portfolios.length != 1) return children;
  return (
    <div className={center({ py: 40, gap: 40, bg: 'background.default.level-1' })}>
      <div className={css({ maxW: 600 })}>{children}</div>
    </div>
  );
};
